import { memo } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import { always, compose, ifElse, isNil, join, length, lt, map, prop, propOr, reject } from 'ramda';
import { useSelector } from 'react-redux';

import { codelists } from 'constants/codelists';
import { getCodelistByName, getCodelistPropById } from 'utils';

export const Row = ({ policy, onSelect, index }) => {
	const productsCodelist = useSelector(getCodelistByName(codelists.products));
	const policyStatusesCodelist = useSelector(getCodelistByName(codelists.policyStatuses));

	const generatePolicyHolder = (policyHolder) => {
		const { firstName, surname, businessName } = policyHolder;
		return reject(isNil, [firstName, surname, businessName]).join(' ');
	};

	return (
		<>
			<TableCell>
				<Link
					underline="none"
					data-policy-id={index}
					id="tableCellPolicySelect"
					onClick={onSelect}
					sx={{ cursor: 'pointer' }}
				>
					{policy.policyNo}
				</Link>
			</TableCell>
			<TableCell>{policy.policyHolder ? generatePolicyHolder(policy.policyHolder) : null}</TableCell>
			<TableCell>
				{ifElse(
					compose(lt(0), length, propOr([], 'productLines')),
					// true
					compose(
						join(', '),
						map((productLine) => getCodelistPropById(productLine, productsCodelist, 'shortDescription')),
						prop('productLines'),
					),
					// false
					always('---'),
				)(policy)}
			</TableCell>
			<TableCell>
				{getCodelistPropById(policy.policyStatusId, policyStatusesCodelist, 'shortDescription')}
			</TableCell>
		</>
	);
};

Row.propTypes = {
	index: PropTypes.number,
	onSelect: PropTypes.func,
	policy: PropTypes.object,
};

export default memo(Row);
